<template>
  <v-data-table
    :headers="headers"
    :items="datas"
    :items-per-page="itemsPerPage"
    @page-count="pageCount = $event"
    :page.sync="page"
    item-key="id"
    hide-default-footer
    hide-default-header
  >
    <template v-slot:header="{ props: { headers } }">
      <thead class="header">
        <tr>
          <th v-for="header in headers" :key="header.text" class="header--text">{{ header.text }}</th>
        </tr>
      </thead>
    </template>

    <template v-slot:item="{ index, item }">
      <tr>
        <td>{{ index + 1 }}</td>
        <td>{{ item.volunteer.name }}</td>
        <td>{{ item.dots_app_status==1?"No":"Yes" }}</td>
        <td>{{ item.date }}</td>

        <td>
          <!-- <v-btn
              @click="goToDetail(item)"
              icon
              color="green lighten-1"
              class="white--text"
              depressed
            >
              <v-icon>mdi-pencil-outline</v-icon>
          </v-btn>-->
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: ["datas"],
  data: () => ({
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    item: {},
    headers: [
      { text: "No", value: "no" },
      { text: "Volunteer", value: "volunteer" },
      { text: "Use App", value: "use_app" },
      { text: "Date", value: "use_app" },
      { text: "Actions", value: "actions" }
    ]
  })
};
</script>

<style>
</style>